import { useState, useEffect, useRef } from 'react';
import { useModel } from '@umijs/max';
import { permissionUrl, fetchOpenConfig } from '@/services';

export default () => {
  const { initWebSocket } = useModel('camera');
  const { settingList, fetchSettingList, setSettingList } = useModel('config');
  const { setInitialState } = useModel('@@initialState');
  const [token, setToken] = useState('');
  const [userInfo, pureSetUserInfo] = useState<API.CurrentUser | undefined>();
  const [robotInfo, pureSetRobotInfo] = useState<API.RobotInfo>({
    username: 'guest',
    password: '123456',
  });
  const settingListRef = useRef(settingList);
  settingListRef.current = settingList;
  const permissions = {
    bankAdd: userInfo?.permissions?.includes(permissionUrl.bankAdd),
    bankDelete: userInfo?.permissions?.includes(permissionUrl.bankDelete),
    bankModify: userInfo?.permissions?.includes(permissionUrl.bankModify),
    bankSearch: userInfo?.permissions?.includes(permissionUrl.bankSearch),
    emergencySearch: userInfo?.permissions?.includes(permissionUrl.emergencySearch),
    emergencyView: userInfo?.permissions?.includes(permissionUrl.emergencyView),
    emergencyQuick: userInfo?.permissions?.includes(permissionUrl.emergencyQuick),
    strategyOrgList: userInfo?.permissions?.includes(permissionUrl.strategyOrgList),
    cameraAdd: userInfo?.permissions?.includes(permissionUrl.cameraAdd),
    cameraBatchAdd: userInfo?.permissions?.includes(permissionUrl.cameraBatchAdd),
    cameraDelete: userInfo?.permissions?.includes(permissionUrl.cameraDelete),
    cameraModify: userInfo?.permissions?.includes(permissionUrl.cameraModify),
    cameraSearch: userInfo?.permissions?.includes(permissionUrl.cameraSearch),
    aiServerAdd: userInfo?.permissions?.includes(permissionUrl.aiServerAdd),
    aiServerActive: userInfo?.permissions?.includes(permissionUrl.aiServerActive),
    aiServerDelete: userInfo?.permissions?.includes(permissionUrl.aiServerDelete),
    aiServerModify: userInfo?.permissions?.includes(permissionUrl.aiServerModify),
    aiServerSearch: userInfo?.permissions?.includes(permissionUrl.aiServerSearch),
    voiceDetail: userInfo?.permissions?.includes(permissionUrl.voiceDetail),
    polygonsShow: true,
  };
  const setUserInfo = (info?: Partial<API.CurrentUser>) => {
    const currentUser = info ? ({ ...userInfo, ...info } as API.CurrentUser) : undefined;
    if (!userInfo && currentUser) {
      initWebSocket();
      fetchSettingList();
    }
    pureSetUserInfo(currentUser);
    setInitialState((s) => ({ ...s, currentUser }));
  };
  const setRobotInfo = (info?: Partial<API.RobotInfo>) => {
    pureSetRobotInfo({
      ...robotInfo,
      ...info,
    });
  };

  useEffect(() => {
    Promise.all([
      fetchOpenConfig('fav_icon'),
      fetchOpenConfig('copyright'),
      fetchOpenConfig('title'),
    ]).then((res) => {
      if (!settingListRef.current.length) {
        setSettingList(res.map((item) => item.content).filter(Boolean));
      }
    });
  }, []);

  return { token, userInfo, robotInfo, permissions, setToken, setUserInfo, setRobotInfo };
};
